﻿export interface IRole {
    id: number,
    roleName: string,
    entityType: number,
    entityTypeId: number
}
